import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'trend'})

export class TrendPipe implements PipeTransform {

	constructor(private translate: TranslateService) {

	}

	transform(input: number, compare: number, percentage: boolean): string {
		if (typeof input === 'undefined') {
			input = 0;
		}

		if (typeof compare === 'undefined') {
			compare = 0;
		}

		let trend;

		if (compare > 0) {
			trend = (((100 / compare) * input) - 100);
		}

		let value = '<span class="filter_original_value">' + input + (percentage ? ' %' : '') + '</span>';

		if (trend > 0) {
			value += ' <span class="green">(';
		} else if (trend < 0) {
			value += ' <span class="red">(';
		} else {
			value += ' <span class="gray">(';
		}

		if (compare === 0) {
			value += this.translate.instant('NOT_APPLICABLE');
		} else {
			// value += this.decimalPipe.transform( trend, '2') + '%';
			value += trend + '%';
		}

		value += ')</span>';

		return value;
	}
}
